import { z } from 'zod';

import type { IdAccountDto } from '@/services/ws-creatives/src/main/resources/rest-api';

export enum BulkUploadNativeSearchKey {
  ACCOUNT_ID = 'accountId',
}

/** Account the upload starts with, carried over from the account filter of the creatives list. */
export const bulkUploadNativeRouterSearchParamsSchema = z.object({
  [BulkUploadNativeSearchKey.ACCOUNT_ID]: z.custom<IdAccountDto>().optional(),
});

export type BulkUploadNativeSearchParams = z.infer<typeof bulkUploadNativeRouterSearchParamsSchema>;
